import { createFileRoute } from "@tanstack/react-router";
import { TradeCityHubPage } from "@/components/hubs/TradeCityHubPage";
import { seoHead } from "@/components/hubs/HubPages";
import { TRADE_CITY_HUBS } from "@/lib/tradeCityHubs";

const HUB = TRADE_CITY_HUBS.find((h) => h.path === "/castle-rock-plumbing-marketing")!;

export const Route = createFileRoute("/castle-rock-plumbing-marketing")({
  head: () => seoHead(HUB.path, HUB.metaTitle, HUB.metaDescription),
  component: () => <TradeCityHubPage hub={HUB} />,
});
